import React, { useEffect, useState } from 'react';
import { Checkbox } from '@repo/common';
import WorkshopListHeader from './WorkshopListHeader';
import WorkshopRow from './WorkshopRow';
import JobBoardPagination from '../../JobBoard/JobBoardPagination';
import {
  getDeletedWorkshopSlotAdminList,
  getWorkshopSlotAdminList,
} from '../../../api/workshop/workshop.api';

const WorkshopList = ({
  currentFilter,
  selectedIds,
  setSelectedIds,
  refreshKey,
  onDeletePermanentlyClick,
  onDeleteClick,
  onActionSuccess,
  appliedFilters,
}) => {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    setCurrentPage(1);
  }, [currentFilter]);

  useEffect(() => {
    const fetchSlots = async () => {
      try {
        setLoading(true);
        const fetchFn =
          currentFilter === 'Deleted Workshops'
            ? getDeletedWorkshopSlotAdminList
            : getWorkshopSlotAdminList;

        const data = await fetchFn({
          page: currentPage - 1,
          size: 12,
          ...appliedFilters,
        });
        setSlots(data.content);
        setTotalPages(data.totalPages);
        setSelectedIds(new Set());
        console.log(data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSlots();
  }, [currentPage, currentFilter, refreshKey, setSelectedIds, appliedFilters]);

  if (error) return <div>Error loading workshops</div>;

  const isAllSelected = slots.length > 0 && selectedIds.size === slots.length;

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(new Set(slots.map((s) => s.slotId)));
    } else {
      setSelectedIds(new Set());
    }
  };

  const handleSelectOne = (slotId, checked) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      checked ? next.add(slotId) : next.delete(slotId);
      return next;
    });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className='flex flex-col p-3 tabletH:p-4 pb-6 items-start w-full min-w-0 rounded-[15px] bg-grayscale-gray00'>
      <WorkshopListHeader
        isAllSelected={isAllSelected}
        onSelectAll={handleSelectAll}
        isDeleted={currentFilter === 'Deleted Workshops'}
      />
      {/* 카드 레이아웃(tabletV 미만)에서는 머리글이 없으므로 전체 선택을 따로 둔다 */}
      {!loading && slots.length > 0 && (
        <label className='tabletV:hidden flex items-center gap-2 px-1 pb-3 typo-b13 text-text-secondary cursor-pointer'>
          <Checkbox checked={isAllSelected} onChange={handleSelectAll} />
          Select all
        </label>
      )}
      {loading ? (
        <div className='flex justify-center items-center w-full text-text-placeholder typo-b14Strong h-[400px] tabletV:h-[694px] pb-[60px]'>
          Loading ...
        </div>
      ) : (
        <>
          <div className='flex flex-col pb-[30px] w-full gap-2'>
            {slots.map((slot) => (
              <WorkshopRow
                key={slot.slotId}
                item={slot}
                checked={selectedIds.has(slot.slotId)}
                onSelect={(checked) => handleSelectOne(slot.slotId, checked)}
                isDeleted={currentFilter === 'Deleted Workshops'}
                onDeletePermanentlyClick={onDeletePermanentlyClick}
                onDeleteClick={onDeleteClick}
                onActionSuccess={onActionSuccess}
              />
            ))}
          </div>
          <JobBoardPagination
            isMyPage
            current={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </>
      )}
    </div>
  );
};

export default WorkshopList;
